@if (config && claimId) {
  <div class="ClaimsSubmission__Instructions">
    <div class="ClaimsSubmission__Layout">
      <h4 class="ClaimsSubmission__Heading">{{ config.body.heading }}</h4>
      <div class="t-html ClaimsSubmission__Details">
        <p role="status">
          {{ config.body.details.confirmationNumberDetails }}
          {{ claimId + '.' }}
          {{ config.body.details.referenceDetails }}
        </p>
        <p class="ClaimsSubmission__Description">
          {{ config.body.details.submittedClaimMsg }}
        </p>
        <p>{{ config.body.details.claimServicesMsg }}</p>
      </div>
    </div>
    <footer class="ClaimsSubmission__Footer">
      <div class="ClaimsSubmission__ClaimsButtons container">
        <zip-button
          class="ClaimsSubmission__ClaimsButton"
          [config]="config.footer.viewSubmittedClaim"
          (click)="viewSubmittedClaim()"
          data-test-id="claimSubmissionContinueButton"
        ></zip-button>
      </div>
    </footer>
  </div>
} @else {
  <div class="u-flex u-justifyCenter u-maxX">
    <preloader size="medium"></preloader>
  </div>
}
